import {
  GET_DIRECTIONS,
  GET_EVENT_TYPES,
  GET_RESPONSIBLE,
  GET_GAMES,
  GET_PLATFORMS,
  GET_VERSIONS,
  GET_CHANNELS,
  GET_CLASS_TAGS,
  GET_TECH_TAGS,
  GET_TYPE_TAGS,
  GET_EXTRA_FIELDS_LIST,
} from '../types';
import network from '../../services/network';
import { callApi } from './utils';

export const getDirections = (...data) => {
  const action = () => network.getDirections(...data);
  return callApi(action, GET_DIRECTIONS);
};

export const getEventTypes = (...data) => {
  const action = () => network.getEventTypes(...data);
  return callApi(action, GET_EVENT_TYPES);
};

export const getResponsible = (...data) => {
  const action = () => network.getResponsible(...data);
  return callApi(action, GET_RESPONSIBLE);
};

export const getGames = (...data) => {
  const action = () => network.getGames(...data);
  return callApi(action, GET_GAMES);
};

export const getPlatforms = (...data) => {
  const action = () => network.getPlatforms(...data);
  return callApi(action, GET_PLATFORMS);
};

export const getVersions = (...data) => {
  const action = () => network.getVersions(...data);
  return callApi(action, GET_VERSIONS);
};

export const getChannels = (...data) => {
  const action = () => network.getChannels(...data);
  return callApi(action, GET_CHANNELS);
};

export const getClassTags = (...data) => {
  const action = () => network.getClassTags(...data);
  return callApi(action, GET_CLASS_TAGS);
};

export const getTechTags = (...data) => {
  const action = () => network.getTechTags(...data);
  return callApi(action, GET_TECH_TAGS);
};

export const getTypeTags = (...data) => {
  const action = () => network.getTypeTags(...data);
  return callApi(action, GET_TYPE_TAGS);
};

export const getExtraFieldsList = () => {
  const action = () => network.getExtraFieldsList();
  return callApi(action, GET_EXTRA_FIELDS_LIST);
};

export const getAppVersionByDirection = (...data) => {
  const action = () => network.getAppVersionByDirection(...data);
  return callApi(action, GET_VERSIONS);
};
